<template>
    <div class="app" :class="appClasses">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'AppWrapper',
    props: {
        color: {
            required: false,
            type: String,
            default: 'bg-transparent',
        },
    },
    computed: {
        appClasses() {
            const cls = {};
            cls['h-screen flex flex-col'] = true;
            cls[this.color] = true;
            return cls;
        },
    },
};
</script>
